<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-input v-model="searchForm.title" placeholder="标题" clearable>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="dialogVisible = true">新增</el-button>
      </el-form-item>
      <el-form-item> </el-form-item>
      <el-form-item>
        <el-popconfirm title="这是确定批量删除吗？" @confirm="delHandle(null)">
          <el-button type="danger" slot="reference" :disabled="delBtlStatu"
            >批量删除</el-button
          >
        </el-popconfirm>
      </el-form-item>

    </el-form>

    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="title" label="标题" width="140"> </el-table-column>
      <el-table-column prop="type" label="类型" width="140">
        <template slot-scope="scope">
          <el-tag size="small" v-if="scope.row.type === '1'" type="success"
            >居家服务</el-tag
          >
          <el-tag size="small" v-else-if="scope.row.type === '2'" type="success"
            >机构养老</el-tag
          >
          <el-tag size="small" v-else-if="scope.row.type === '3'" type="success"
            >适老化改造</el-tag
          >
          <el-tag size="small" v-else-if="scope.row.type === '4'" type="success"
            >家庭床位</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="represent" label="内容" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="icon" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="editHandle(scope.row.id)"
            >编辑</el-button
          >
          <el-divider direction="vertical"></el-divider>

          <template>
            <el-popconfirm
              title="这是一段内容确定删除吗？"
              @confirm="delHandle(scope.row.id)"
            >
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="current"
      :page-size="size"
      :total="total"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        :rules="editFormRules"
        ref="editForm"
        label-width="100px"
        class="demo-editForm"
      >
        <el-form-item label="标题" prop="title" label-width="100px">
          <el-input v-model="editForm.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="editForm.type" placeholder="全部" value-key="id">
            <el-option value="" label="请选择" />
            <el-option
              v-for="item in optionsItem"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="内容" prop="represent" label-width="100px">
          <el-input
            v-model="editForm.represent"
            autocomplete="off"
            autosize
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="地区"
          prop="param"
          label-width="100px"
          v-if="this.userInfo.id == '1'"
        >
          <el-select
            v-model="editForm.zoneId"
            placeholder="全部"
            ref="cityLabel"
          >
            <template v-for="item in area">
              <el-option :label="item.cityName" :value="item.id"></el-option>
            </template>
          </el-select>
        </el-form-item>

        <el-form-item label="封面图片" prop="imgList" label-width="100px">
          <el-upload
            action="http://47.96.28.227:8081/hg/upload/0"
            list-type="picture-card"
            :multiple="true"
            :limit="5"
            :headers="headermsg"
            ref="upload"
            :file-list="fileList"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-success="onSuccess"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('editForm')"
            >立即创建</el-button
          >
          <el-button @click="resetForm('editForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "homePage",
  data() {
    return {
      // content: `欢迎使用`,
      userInfo: {},
      optionsItem: [
        {
          value: "1",
          label: "居家服务",
        },
        {
          value: "2",
          label: "机构养老",
        },
        {
          value: "3",
          label: "适老化改造",
        },
        {
          value: "4",
          label: "家庭床位",
        },
      ],
      value: 0,
      editorOption: {},
      dialogImageUrl: "",
      searchForm: {},
      delBtlStatu: true,
      total: 0,
      size: 10,
      current: 1,
      dialogVisible: false,
      editForm: {},
      url: "http://hk-huanggang.oss-cn-hangzhou.aliyuncs.com/",
      userInfo: {
        id: "",
        username: "",
        avatar: "",
        roles: "",
      },
      imgUrl: "",
      headermsg: {
        Authorization: "",
      },
      tableData: [],
      stlectList: [],
      editFormRules: {},
      imgList: [],
      fileList: [],
      area: [],
    };
  },
  computed: {},
  created() {
    this.getSelectList();
    this.getRoleList();
    this.$axios.get("/gw/sys/menu/list").then((res) => {
      this.permTreeData = res.data.data;
    });
    const userInfo = localStorage.getItem("userInfo");
    const token = localStorage.getItem("token");
    this.headermsg.Authorization = token;
    if (userInfo != null) {
      this.userInfo = JSON.parse(userInfo);
    }
  },
  methods: {
    handleRemove(file, fileList) {
      let arr = [];
      for (let i = 0; i < this.imgList.length; i++) {
        if (file.url.indexOf(this.imgList[i]) < 0) {
          arr.push(this.imgList[i]);
        }
      }
      this.imgList = arr;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onSuccess: function (res) {
      if (res.code == 200) {
        this.imgList.push(res.data);
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {

      this.multipleSelection = val;

      this.delBtlStatu = val.length == 0;
    },

    handleSizeChange(val) {
      var _this = this;
      this.size = val;
    },
    handleCurrentChange(val) {
      var _this = this;
      this.current = val;
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.editForm = {};
    },
    handleClose() {
      this.fileList = [];
      this.imgList = [];
      this.resetForm("editForm");
    },
    changeFlag(val) {
      this.current = 1;
    },
    getRoleList() {
      this.$axios
        .get("/gw/zone/list", {
          params: {
            name: "",
            current: 1,
            size: 20,
          },
        })
        .then((res) => {
          this.area = res.data.data;
        });
    },
    getSelectList() {
      this.$axios
        .post("/gw/organization/list", {
          params: {
            // name: this.searchForm.name,
            current: this.current,
            size: this.size,
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.tableData = res.data.data.records;
          }
        });
    },
    submitForm(formName) {
      if (this.userInfo.id == "1") {
        if (
          this.editForm.zoneId == "" ||
          typeof this.editForm.zoneId == "undefined"
        ) {
          this.$message({
            message: "区域必须选择",
            duration: 1000,
            type: "error",
          });
          return;           }
      }
      if (this.editForm.type != 2) {
        if (this.imgList.length < 3) {
          this.$message({
            message: "图片至少上传三张",
            duration: 1000,
            type: "error",
          });
          return;
        }
      } else {
        if (this.imgList.length < 5) {
          this.$message({
            message: "图片需上传五张",
            duration: 1000,
            type: "error",
          });
          return;
        }
      }
      if (this.editForm.id) {
        this.editForm.updateId = this.userInfo.id;
        this.editForm.updateName = this.userInfo.username;
      } else {
        this.editForm.createId = this.userInfo.id;
        this.editForm.createName = this.userInfo.username;
      }
      this.editForm.pictures = this.imgList.join(",");
      // return;

      this.$axios
        .post(
          "/gw/organization/" + (this.editForm.id ? "update" : "save"),
          this.editForm
        )
        .then((res) => {
          if (res.status == 200) {
            this.$message({
              message: "恭喜你，操作成功",
              duration: 1000,
              type: "success",
            });
            this.getSelectList();
            this.fileList = [];
            this.resetForm("editForm");
            this.imgList = [];
            this.dialogVisible = false;
          } else {
            this.$message({
              message: "res.msg",
              duration: 1500,
              type: "error",
            });
          }

          this.dialogVisible = false;
          // this.resetForm(formName);
        });
    },
    editHandle(id) {
      this.$axios.get("/gw/organization/info/" + id).then((res) => {
        if (res.status == 200) {
          this.imgList = res.data.data.pictures.split(",");
          this.fileList = [];
          for (let i = 0; i < this.imgList.length; i++) {
            let obj = {};
            obj.url = this.url + this.imgList[i];
            this.fileList.push(obj);
          }
          this.editForm = res.data.data;
          this.dialogVisible = true;
        }
      });
    },
    delHandle(id) {
      var ids = [];

      if (id) {
        ids.push(id);
      } else {
        this.multipleSelection.forEach((row) => {
          ids.push(row.id);
        });
      }

      this.$axios.post("/gw/organization/delete", ids).then((res) => {
        if (res.status == 200) {
          this.$message({
            message: "恭喜你，操作成功",
            duration: 1000,
            type: "success",
          });
          this.imgList = [];
          this.getSelectList();
          this.fileList = [];
          this.resetForm("editForm");
          this.dialogVisible = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.el-pagination {
  float: right;
  margin-top: 22px;
}
</style>
